const EVENTS_IT = {
  accepted: "Offerta accettata dal cliente",
  booking_auto_extended: "Proroga automatica",
  booking_end: "Richiesta di fine prenotazione",
  booking_extension: "Richiesta di proroga",
  break_repair: "Guasti significativi",
  break_repair_2: "Piccoli guasti",
  breakdown: "Guasto",
  breakdown_electric: "Guasto elettrico",
  breakdown_engine: "Guasto al motore",
  breakdown_mecanic: "Guasto meccanico",
  breakdown_other: "Altro guasto",
  canceled: "Annullato",
  closed: "Chiuso",
  confirmed: "Ordine confermato",
  damages_third_parties: "Richiesta danni legali",
  delay_in_delivery: "Ritardo nella consegna",
  deliveryOn: "Consegna il",
  document_compliance: "Conformità dei documenti",
  events: "{{count}} eventi",
  forgetting_extend: "Dimenticato di prorogare",
  forgetting_recover: "Dimenticato di recuperare",
  from_date: "Inizio",
  hours_record: "Registro ore",
  immobilisation: "Immobilizzazione",
  incompetent_operator: "Operatore incompetente",
  inventory: "Inventario",
  keys: "Chiave/Codice: smarrita/non comunicata",
  machine_delivery: "Consegna",
  machine_retrieval: "Recupero",
  missing_accessory: "Accessorio mancante",
  n1_control: "Controllo N1",
  n2_control: "Controllo N2",
  n3_control: "Controllo N3",
  no_show: "Consegna: Assente",
  open: "Aperto",
  openEvents: "Eventi aperti",
  operator_change: "Cambio operatore",
  other: "Altro",
  other_delivery: "Altra consegna",
  other_request: "Altra richiesta",
  quality_issue: "Attrezzatura in cattive condizioni",
  retrievalOn: "Recupero il",
  robbery_accessory: "Furto accessorio",
  robbery_article: "Furto macchina",
  sent: "Richiesta ricevuta",
  to_date: "Fine",
  undeclared_use: "Uso non dichiarato",
  validated: "Richiesta di prenotazione validata",
  weather: "Maltempo",
  wrong_machine: "Errore attrezzatura",
  wrong_reclassification: "Selezione macchina errata",
} as const;

export default EVENTS_IT;
